<template>
    <div v-if="selectedPaymentType && !isGroupParticipant">
        <h2>{{$t('eventRegistration.summary.paymentType')}}</h2>
        <div class="card mb-0">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <font-awesome-icon :icon="icon" size="2x" />
                    <span class="font-weight-bold ml-3">{{selectedPaymentType.type.name}}</span>
                </div>
                <div class="mt-3" v-if="selectedPaymentType.type.id === 1">
                    <div class="row align-items-center">
                        <div class="col-xl-4 font-weight-bold">
                            {{$t('eventRegistration.payment.iban')}}:
                        </div>
                        <div class="col-xl-auto">
                            {{iban}}
                        </div>
                    </div>
                    <div v-if="alternativeAccountHolder" class="row align-items-center">
                        <div class="col-xl-4 font-weight-bold">
                            {{$t('eventRegistration.payment.alternativeAccountHolder')}}:
                        </div>
                        <div class="col-xl-auto">
                            {{alternativeAccountHolder}}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import registrationPaymentMixin from "@/mixins/registration/registrationPaymentMixin";
import registrationGroupMixin from "@/mixins/registration/registrationGroupMixin";

export default {
    name: "Payment",
    mixins: [registrationPaymentMixin, registrationGroupMixin],
    computed: {
        icon() {
            if (this.selectedPaymentType) {
                switch (this.selectedPaymentType.type.id) {
                    case 1:
                        return "credit-card"
                    case 2:
                        return "file-invoice"
                    case 3:
                        return ['fab', 'paypal']
                    case 4:
                        return "coins"
                }
            }
            return null
        }
    }
}
</script>

<style scoped>

</style>
